import { Instagram, MessageCircle } from "lucide-react";
import sethLogo from "@/assets/seth-logo.png";
import { NAV, wa, WA_NUMBER_DISPLAY } from "@/lib/site";

const Footer = () => (
    <footer data-testid="footer-section" className="bg-[#050506] border-t border-line/60">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
            <div className="flex flex-col gap-5 items-start">
                <a href="#inicio" data-testid="footer-logo" aria-label="SETH Soluções Digitais — Início">
                    <img src={sethLogo} alt="SETH Soluções Digitais" className="h-10 w-auto" />
                </a>
                <p className="text-sm text-ink2 leading-relaxed max-w-xs">
                    SETH Soluções Digitais
                    <br />
                    Estratégia para pequenos negócios no digital.
                </p>
            </div>

            <div className="flex flex-col gap-5">
                <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-gold">Navegação</p>
                <nav className="flex flex-col gap-3" aria-label="Navegação do rodapé">
                    {NAV.filter((n) => n.href !== "#inicio").map((item) => (
                        <a
                            key={item.href}
                            href={item.href}
                            data-testid={`footer-nav-${item.href.replace("#", "")}`}
                            className="text-sm text-ink2 hover:text-gold transition-colors duration-300 w-fit"
                        >
                            {item.label}
                        </a>
                    ))}
                </nav>
            </div>

            <div className="flex flex-col gap-5">
                <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-gold">Contato</p>
                <div className="flex flex-col gap-3">
                    <a
                        href={wa()}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-whatsapp"
                        className="inline-flex items-center gap-2.5 text-sm text-ink2 hover:text-gold transition-colors duration-300 w-fit"
                    >
                        <MessageCircle size={15} className="text-gold" />
                        WhatsApp: {WA_NUMBER_DISPLAY}
                    </a>
                    <a
                        href="https://www.instagram.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-instagram"
                        className="inline-flex items-center gap-2.5 text-sm text-ink2 hover:text-gold transition-colors duration-300 w-fit"
                    >
                        <Instagram size={15} className="text-gold" />
                        Instagram
                    </a>
                </div>
            </div>
        </div>

        <div className="border-t border-line/60">
            <div className="mx-auto max-w-7xl px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
                <p className="text-xs text-ink3">
                    © 2026 SETH Soluções Digitais. Todos os direitos reservados.
                </p>
                <p className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-ink3">
                    Estratégia + Tecnologia + Presença Digital + Resultado
                </p>
            </div>
        </div>
    </footer>
);

export default Footer;
